module.exports = __webpack_public_path__ + "img/loupe2.0ad27261.svg";